import { useCallback } from 'react';
import { AxiosResponse } from 'axios';
import { ResponseWithPagination } from '@/types';
import { PaginationParams } from '@/types/api';

const useApiFetchAll = <Data = unknown>(
  queryFn: (params: PaginationParams) => Promise<AxiosResponse<ResponseWithPagination<Data[]>>>,
  options?: {
    take?: number;
  }
): (() => Promise<Data[]>) => {
  const take = options?.take || 10;

  const fn = useCallback(async () => {
    const data: Data[] = [];

    let response = await queryFn({
      page: 1,
      take,
    });

    data.push(...response.data.data);

    while (response.data.nextPage) {
      response = await queryFn({
        page: response.data.nextPage,
        take,
      });

      data.push(...response.data.data);
    }

    return data;
  }, [queryFn, take]);

  return fn;
};

export default useApiFetchAll;
